// cloud-super-admin panelinin kendi menü bölümleri için izin anahtarları.
// Backend'deki cloud-media-backend/src/middleware/adminMenuPermissionMiddleware.js
// ve route dosyalarındaki requireAdminMenuAccess(key) çağrılarıyla birebir eşleşmelidir.
export interface AdminMenuPermission {
  key: string
  label: string
}

export const ADMIN_MENU_PERMISSIONS: AdminMenuPermission[] = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'companies', label: 'Firma Yönetimi' },
  { key: 'email-templates', label: 'Email Şablonları' },
  { key: 'tickets', label: 'Destek Talepleri' },
  { key: 'help-articles', label: 'Yardım Makaleleri' },
  { key: 'users', label: 'Kullanıcı Yönetimi' },
  { key: 'devices', label: 'Cihaz Yönetimi' },
  { key: 'device-logs', label: 'Cihaz Logları' },
  { key: 'announcements', label: 'Anonslar' },
  { key: 'ai-announcements', label: 'AI Anonslar' },
  { key: 'ai-music', label: 'AI Müzik' },
  { key: 'music-upload', label: 'Müzik Yükleme' },
  { key: 'playlists', label: 'Playlist Yönetimi' },
  { key: 'taxonomy', label: 'Taksonomi' },
  { key: 'notices', label: 'Duyurular' },
  { key: 'analytics', label: 'Analitik' },
  { key: 'system-settings', label: 'Sistem Ayarları' }
]

export const ALL_ADMIN_MENU_KEYS = ADMIN_MENU_PERMISSIONS.map(p => p.key)

interface PermissionCheckUser {
  role?: string
  permissions?: string[]
}

// Boş/undefined permissions = tam yetki (backend ile aynı geriye dönük uyumlu varsayılan).
export const hasAdminMenuAccess = (user: PermissionCheckUser | null | undefined, key: string): boolean => {
  if (!user) return false
  if (user.role !== 'super_admin') return true
  if (!user.permissions || user.permissions.length === 0) return true
  return user.permissions.includes(key)
}
